import image_1 from '../images/sgu/318583879_3302012560023492_6756216758577762874_n.jpg'
import image_2 from '../images/sgu/336451328_951981602485014_8955099830520786775_n.jpg'
import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
export default function SliderImage() {
    return (
        <div className="slider-image">
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                className="swiper-home"
            >
                <SwiperSlide>
                    <div className="slider-image--item">
                        <img src={image_1} alt="" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slider-image--item">
                        <img src={image_2} alt="" />
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    )
}